import React, { useRef, useState } from 'react';
import { GenericHeader } from '../../../Components/GenericHeader/GenericHeader';
import { Footer } from '../../../Components/Footer/Footer';
import { shareCSS } from './Share.css';
import { useParams } from 'react-router-dom';
import { peicarLogo2 } from '../../../Assets/Images';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import axios from 'axios';
import { api, url } from '../../../env';
import { Loader } from '../../../Components';

export default function Share() {
    const { secret } = useParams();
    const shareUrl = `${window.location.origin}/cotizar/${secret}?share=true`;
    const [showEmailDialog, setShowEmailDialog] = useState(false);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const toast = useRef(null);



    const handleWhatsApp = () => {
        const text = encodeURIComponent(
            `¡Hola! Gracias por tu interés en PEICAR\n\n` +
            `Aquí te comparto la cotización que preparé especialmente para ti, con las mejores condiciones de financiamiento:\n\n` +
            `>> Tasa preferencial\n` +
            `>> Mensualidades fijas\n` +
            `>> Aprobación express\n\n` +
            `* Revisa los detalles aquí: ${shareUrl}\n\n` +
            `Quedo atento a tus comentarios para resolver cualquier duda y ayudarte a estrenar tu auto nuevo.`
        );
        window.open(`https://wa.me/?text=${text}`, '_blank');
    };

    const handleEmailSubmit = async () => {
        // Evitar múltiples envíos mientras está cargando
        if (loading) return;

        if (!email) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Por favor ingresa un correo electrónico',
                life: 3000
            });
            return;
        }


        setLoading(true);
        try {
            await axios.post(`${url}/shareBudgetByEmail`, {
                email,
                budget_secret: secret,
                share_code: secret
            });

            toast.current.show({
                severity: 'success',
                summary: 'Éxito',
                detail: 'Cotización enviada correctamente',
                life: 3000
            });
            setShowEmailDialog(false);
            setEmail('');
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error al enviar el correo',
                life: 3000
            });
        } finally {
            // Asegurarnos de que el loading se desactive después de un pequeño delay
            setTimeout(() => {
                setLoading(false);
            }, 300);
        }
    };

    const handleCopy = async () => {
        await navigator.clipboard.writeText(shareUrl);
        toast.current.show({
            severity: 'success',
            summary: 'Éxito',
            detail: 'Enlace copiado al portapapeles',
            life: 3000
        });
    };

    return (
        <div css={shareCSS()}>
            <Toast ref={toast} />
            {loading && <Loader />}
            <GenericHeader />

            <section>
                <div className="share-container">
                    <img src={peicarLogo2} alt="PEICAR" className="logo" />
                    <h2>Comparte tu cotización</h2>

                    <div className="ButtonRow">
                        <div className="Button Green" onClick={handleWhatsApp}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="30"
                                height="30"
                                viewBox="0 0 40 40"
                            >
                                <path
                                    fill="currentColor"
                                    d="M34.13 5.714a19.316 19.316 0 0 0-13.845-5.71c-10.714 0-19.428 8.714-19.428 19.428 0 3.428.893 6.75 2.572 9.75L0 40l10.428-2.714a19.197 19.197 0 0 0 9.857 2.714h.036c10.714 0 19.393-8.714 19.393-19.428 0-5.214-2-10.107-5.607-13.857zM20.286 36.643h-.036a16.143 16.143 0 0 1-8.178-2.25l-.572-.357-6.107 1.607 1.607-5.929-.393-.607a16.214 16.214 0 0 1-2.464-8.536c0-8.928 7.286-16.214 16.214-16.214 4.321 0 8.393 1.714 11.464 4.75 3.071 3.071 4.75 7.143 4.75 11.464-.036 8.964-7.321 16.072-16.285 16.072zm8.893-12.107c-.5-.25-2.857-1.429-3.321-1.571-.429-.143-.75-.214-1.071.214-.321.429-1.25 1.571-1.536 1.893-.286.321-.571.357-1.071.107-.5-.25-2.107-.75-4-2.429-1.464-1.321-2.464-2.964-2.75-3.464-.286-.5-.036-.75.214-1 .214-.214.5-.571.75-.857.25-.286.321-.5.5-.821.179-.321.071-.607-.036-.857-.107-.25-1.071-2.607-1.464-3.571-.393-.929-.786-.786-1.071-.786-.286 0-.607-.036-.929-.036s-.857.107-1.286.607c-.429.5-1.679 1.643-1.679 4 0 2.357 1.714 4.643 1.929 4.964.214.321 3.107 4.714 7.5 6.607 1.036.429 1.857.714 2.5.929.964.321 1.893.286 2.607.179.786-.107 2.607-1.071 2.964-2.107.357-1.036.357-1.929.25-2.107-.107-.214-.429-.357-.929-.607z"
                                />
                            </svg>
                            <p className="WhatsApp ml-4">WhatsApp</p>
                        </div>

                        <div className="Button Blue" onClick={() => setShowEmailDialog(true)}>
                            Correo
                        </div>

                        <div className="Button Green" onClick={handleCopy}>
                            Copiar enlace
                        </div>
                    </div>
                </div>
            </section>

            <Dialog
                visible={showEmailDialog}
                onHide={() => setShowEmailDialog(false)}
                header="Enviar por correo"
                style={{
                    width: '50vw',
                    zIndex: '1000'
                }}
                contentStyle={{
                    background: 'white',
                    padding: '2rem'
                }}
                maskStyle={{
                    zIndex: '999'
                }}
                draggable={false}
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                className="share-dialog Modal"
            >
                <div className="p-fluid">
                    <div className="p-field">
                        <label htmlFor="email" className="mb-2">Correo electrónico</label>
                        <InputText
                            id="email"
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Ingresa el correo electrónico"
                            className="mb-3"
                        />
                    </div>
                    <Button
                        label="Enviar"
                        onClick={handleEmailSubmit}
                        style={{
                            backgroundColor: '#34C6F1',
                            border: 'unset',
                            borderRadius: '8px',
                            color: 'white',
                            fontWeight: '600',
                            '&:hover': {
                                backgroundColor: '#2da5c8',
                                border: 'unset'
                            },
                        }}
                    />
                </div>
            </Dialog>

            <Footer />
        </div>
    );
}
